import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import * as c from '../../constants';
import AuthenticatorSetup from './components/AuthenticatorSetup';
import EmailSetup from './components/EmailSetup';
import AuthenticatorConfirm from './components/AuthenticatorConfirm';

function MfaModal({
  profile,
}) {

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedMfa, setSelectedMfa] = useState(0);

  const [formData, setFormData] = useState({
    preferred_mfa: profile.preferred_mfa || '',
    title: ''
  });

  const handleOnClickSetting = item => e => {
    e.preventDefault();
    setSelectedMfa(0);
    setFormData({
      preferred_mfa: item.preferred_mfa,
      title: item.title
    });
  };

  const handleNext = () => {
    if (selectedIndex === 0) {
      setSelectedIndex(1);
    }
  };

  useEffect(() => {
    if (profile.is_email_2fa_enabled === true && profile.preferred_mfa === 'email_otp') {
      setSelectedIndex(1);
    }
  }, []);

  useEffect(() => {
    if (profile.is_google_2fa_enabled === true && profile.preferred_mfa === 'google_authenticator') {
      setSelectedIndex(1);
    }
  }, []);

  const handleCheckedBox = e => {
    if (e.target.checked) {
      setSelectedMfa(1);
    } else {
      setSelectedMfa(0);
    }
  };

  const goBack = () => {
    setSelectedIndex(0)
    setSelectedMfa(0);
    setFormData({
      preferred_mfa: ''
    })
  };

  return (
    <Modal.Body className='mfa-modal'>
      {(selectedIndex === 0) && (
        <>
          <div className="row">
            <div className="col-12 title">
              Add an extra layer of security to your account by enabling
              Multi-Factor Authentication (MFA).
            </div>
            <div className="col-12 title">
              Select one of the following methods to complete login:
            </div>
          </div>
          <div className="row mt-3">
            {c.mfaSettings.length > 0 ? (
              c.mfaSettings
                .map(item => {
                  return (
                    <React.Fragment key={item.preferred_mfa}>
                      <button
                        key={`module-${item.preferred_mfa}`}
                        type="button"
                        onClick={handleOnClickSetting(item)}
                        className="col-12 btn-blank"
                      >
                        <div className={`item-card animated fadeIn ${item.preferred_mfa === formData.preferred_mfa ? 'selected-mfa' : ''}`}>
                          <div className="container-fluid h-100">
                            <div className="row d-flex align-items-center h-100">
                              <div className="col-2">
                                <span className="fa-stack">
                                  <i className={`fa ${item.icon} icon-circle fa-solid fa-stack-1x`} />
                                </span>
                              </div>
                              <div className="col-10 align-self-center pl-0 text-left">
                                <div className="title">
                                  {item.title}
                                </div>
                                <div className="description">
                                  {item.description}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </button>
                    </React.Fragment>
                  );
                })
            ) : (
              <div className="d-flex align-items-center justitfy-content-center h-100">
                <div className="text-center mx-auto py-4">
                  <img
                    src={emptyStateImage}
                    className="img-responsive image-wrapper mb-4 mt-3"
                    alt="Empty State"
                  />
                  <p className="emp-title mb-0"> No Item Found </p>
                </div>
              </div>
            )}
          </div>
          <div className="d-flex flex-row flex-fill login-save mt-2">
            <input
              name="change_mfa"
              type="checkbox"
              className="button-select"
              disabled={formData.preferred_mfa === ''}
              value={selectedMfa}
              checked={selectedMfa === 0 ? 0 : 1}
              onChange={handleCheckedBox}
            />
            <label className="description mb-0">Save my choice for future logins</label>
          </div>
          <hr className="below-hr" />
          <div className='mfa-modal'>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={handleNext}
                disabled={selectedIndex === 0 && formData.preferred_mfa === ''}
                className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
              >
                <span className="font-weight-bold">
                  Continue
                </span>
              </button>
            </div>
          </div>
        </>
      )}
      {(profile.is_google_2fa_enabled === false && formData.preferred_mfa === 'google_authenticator' && selectedIndex !== 0) && (
        <AuthenticatorSetup profile={profile} formData={formData} goBack={goBack} selectedMfa={selectedMfa} />
      )}
      {(formData.preferred_mfa === 'email_otp' && selectedIndex !== 0) && (
        <EmailSetup profile={profile} formData={formData} goBack={goBack} selectedMfa={selectedMfa} />
      )}
      {(profile.is_google_2fa_enabled === true && (formData.preferred_mfa === 'google_authenticator' || formData.preferred_mfa === '') && selectedIndex !== 0) && (
        <AuthenticatorConfirm profile={profile} formData={formData} goBack={goBack} selectedMfa={selectedMfa} />
      )}
    </Modal.Body>
  );
}

MfaModal.defaultProps = {
  profile: {},
};

MfaModal.propTypes = {
  profile: PropTypes.instanceOf(Object),
};

const mapStateToProps = () => ({
  profile: JSON.parse(sessionStorage.getItem('profile')),
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(MfaModal);